import { render, staticRenderFns } from "./AddFrameCommand.vue?vue&type=template&id=6385eba3"
import script from "./AddFrameCommand.vue?vue&type=script&lang=ts"
export * from "./AddFrameCommand.vue?vue&type=script&lang=ts"
import style0 from "./AddFrameCommand.vue?vue&type=style&index=0&id=6385eba3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports